/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseServiceAreaDto
 */
export interface WarehouseServiceAreaDto {
    /**
     * Service area ID
     * @type {number}
     * @memberof WarehouseServiceAreaDto
     */
    id: number;
    /**
     * Warehouse ID
     * @type {number}
     * @memberof WarehouseServiceAreaDto
     */
    warehouseId: number;
    /**
     * Country code (ISO 3166-1 alpha-3)
     * @type {string}
     * @memberof WarehouseServiceAreaDto
     */
    countryCode: string;
    /**
     * Admin area 1 code (province/state)
     * @type {string}
     * @memberof WarehouseServiceAreaDto
     */
    adminArea1Code: string | null;
    /**
     * Admin area 2 code (city/district)
     * @type {string}
     * @memberof WarehouseServiceAreaDto
     */
    adminArea2Code: string | null;
    /**
     * Timestamp created at
     * @type {Date}
     * @memberof WarehouseServiceAreaDto
     */
    createdAt: Date;
    /**
     * Timestamp updated at
     * @type {Date}
     * @memberof WarehouseServiceAreaDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the WarehouseServiceAreaDto interface.
 */
export function instanceOfWarehouseServiceAreaDto(value: object): value is WarehouseServiceAreaDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('adminArea1Code' in value) || value['adminArea1Code'] === undefined) return false;
    if (!('adminArea2Code' in value) || value['adminArea2Code'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function WarehouseServiceAreaDtoFromJSON(json: any): WarehouseServiceAreaDto {
    return WarehouseServiceAreaDtoFromJSONTyped(json, false);
}

export function WarehouseServiceAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseServiceAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'warehouseId': json['warehouseId'],
        'countryCode': json['countryCode'],
        'adminArea1Code': json['adminArea1Code'],
        'adminArea2Code': json['adminArea2Code'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function WarehouseServiceAreaDtoToJSON(value?: WarehouseServiceAreaDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'warehouseId': value['warehouseId'],
        'countryCode': value['countryCode'],
        'adminArea1Code': value['adminArea1Code'],
        'adminArea2Code': value['adminArea2Code'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

